// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import './Orders.css';

// const OrdersPage = () => {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//     useEffect(() => {
//         const fetchOrders = async () => {
//             try {
//                 const token = localStorage.getItem("access_token");
//                 if (!token) {
//                     alert("You must be logged in to view your orders.");
//                     return;
//                 }

//                 const response = await axios.get("http://127.0.0.1:8000/api/orders/", {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 });

//                 // Sort orders by created_at (most recent first)
//                 const sortedOrders = response.data.sort((a, b) =>
//                     new Date(b.created_at) - new Date(a.created_at)
//                 );

//                 setOrders(sortedOrders);
//             } catch (err) {
//                 setError("Failed to load orders. Please try again.");
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchOrders();
//     }, []);

//     if (loading) {
//         return <p>Loading orders...</p>;
//     }

//     if (error) {
//         return <p>{error}</p>;
//     }

//     return (
//         <div class="orderpage">
//             <h2 class="headingtitle">Your Orders</h2>
// <div className="orderList">
//     {orders.length > 0 ? (
//         <ul className="orderList">
//             {orders.map((order) => {
//                 // Parse shipping_address if it's a string
//                 const parsedShippingAddress = typeof order.shipping_address === 'string'
//                     ? JSON.parse(order.shipping_address)
//                     : order.shipping_address;

//                 return (
//                     <li key={order.id}>
//                         <div className="perList">
//                             <div className="order-listdesc">
//                                 <h2>Order ID: {order.id}</h2>
//                                 <p>Total Price: ${order.total_price}</p>
//                                 <p>Status: {order.status}</p>
//                                 <p>Created At (UTC): {new Date(order.created_at).toLocaleString()}</p>
//                             </div>
//                             {/* Render Shipping Address */}
//                             {parsedShippingAddress && (
//                                 <div className="order-shipping">
//                                     <h3>Shipping Address:</h3>
//                                     <div class="order-shipping-address">
//                                         <p>Line 1: {parsedShippingAddress.line1}</p>
//                                         <p>Line 2: {parsedShippingAddress.line2 || 'N/A'}</p>
//                                         <p>City: {parsedShippingAddress.city}</p>
//                                         <p>State: {parsedShippingAddress.state}</p>
//                                         <p>Postal Code: {parsedShippingAddress.postal_code}</p>
//                                         <p>Country: {parsedShippingAddress.country}</p>
//                                     </div>
//                                 </div>
//                             )}
//                             <div className="order-listitem">
//                                 <h3>Items:</h3>
//                                 <ul>
//                                     {order.order_items.map((item) => (
//                                         <li key={item.product}>
//                                             <p>Product: {item.product_name}</p>
//                                             <p>Quantity: {item.quantity}</p>
//                                             <p>Price: ${item.product_price}</p>
//                                             <p>Total: ${item.quantity * item.product_price}</p>
//                                         </li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </li>
//                 );
//             })}
//         </ul>
//     ) : (
//         <p>No orders found.</p>
//     )}
//             </div>
//         </div>
//     );
// };

// export default OrdersPage;

import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Orders.css";

import { API_URL } from "../services/api";

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("access_token");
        if (!token) {
          alert("You must be logged in to view your orders.");
          return;
        }

        const response = await axios.get(`${API_URL}api/orders/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        // Sort orders by created_at (most recent first)
        const sortedOrders = response.data.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setOrders(sortedOrders);
      } catch (err) {
        setError("Failed to load orders. Please try again.");
        window.location.href = "/logout/";
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) {
    return <p>Loading orders...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="orderpage">
      <h2 className="headingtitle">Your Orders</h2>
      <div className="orderList">
        {orders.length > 0 ? (
          <ul className="orderList">
            {orders.map((order) => {
              const parsedShippingAddress =
                typeof order.shipping_address === "string"
                  ? JSON.parse(order.shipping_address)
                  : order.shipping_address;

              return (
                <li id="eachList-li" key={order.id}>
                  <div className="perList">
                    <div className="order-listdesc">
                      <h2>Order ID: {order.id}</h2>
                      <p>Total Price: ${order.total_price}</p>
                      <p>Status: {order.status}</p>
                      <p>
                        Created At (UTC):{" "}
                        {new Date(order.created_at).toLocaleString()}
                      </p>

                      {/* ✅ Conditionally show shipping fees */}
                      {order.order_total_shipping_fees && (
                        <p>Shipping Fees: ${order.order_total_shipping_fees}</p>
                      )}

                      {/* ✅ Conditionally show tracking number */}
                      {order.tracking_number && (
                        <p>Tracking Number: {order.tracking_number}</p>
                      )}

                      {/* ✅ Conditionally show notes */}
                      {order.notes && <p>Notes: {order.notes}</p>}

                      {/* ✅ Conditionally show card brand */}
                      {order.card_brand && <p>Card Used: {order.card_brand}</p>}

                      {/* ✅ Conditionally show billing address */}
                      {order.billing_address && (
                        <p id="billing-address-text">
                          Billing Address: {order.billing_address}
                        </p>
                      )}
                    </div>

                    {parsedShippingAddress && (
                      <div className="order-shipping">
                        <h3 id="shipping-address-text">Shipping Address:</h3>
                        <div className="order-shipping-address">
                          <p>Line 1: {parsedShippingAddress.line1}</p>
                          <p>Line 2: {parsedShippingAddress.line2 || "N/A"}</p>
                          <p>City: {parsedShippingAddress.city}</p>
                          <p>State: {parsedShippingAddress.state}</p>
                          <p>
                            Postal Code: {parsedShippingAddress.postal_code}
                          </p>
                          <p>Country: {parsedShippingAddress.country}</p>
                        </div>
                      </div>
                    )}
                    {order.notes &&
                      (() => {
                        try {
                          const discountInfo = JSON.parse(order.notes);
                          if (discountInfo.discount_applied) {
                            return (
                              <div className="discount-info">
                                <h4>Discount Applied:</h4>
                                <p>Code: {discountInfo.discount_code}</p>
                                <p>
                                  Original Total: $
                                  {discountInfo.global_original_total}
                                </p>
                                <p>
                                  Discount: -$
                                  {discountInfo.global_discount_amount}
                                </p>
                                <p>
                                  Final Total: $
                                  {discountInfo.global_discounted_total}
                                </p>
                                {discountInfo.related_orders &&
                                  discountInfo.related_orders.length > 0 && (
                                    <p>
                                      Related Orders:{" "}
                                      {discountInfo.related_orders.join(", ")}
                                    </p>
                                  )}
                                <p>
                                  This Order Original amount: $
                                  {order.total_price}
                                </p>
                              </div>
                            );
                          }
                        } catch (e) {
                          return null;
                        }
                        return null;
                      })()}
                    <div className="order-listitem">
                      <h3 id="items-headertext">Items:</h3>
                      <ul>
                        {order.order_items.map((item) => (
                          <li key={item.id}>
                            <p>Product: {item.product_name}</p>
                            <p>Quantity: {item.quantity}</p>
                            <p>Price: ${item.product_price}</p>
                            <p>Total: ${item.total_price}</p>

                            {item.variant_options &&
                              Object.keys(item.variant_options).length > 0 && (
                                <ul>
                                  {Object.entries(item.variant_options).map(
                                    ([option, value], index) => (
                                      <li key={index}>
                                        {option}: {value || "N/A"}
                                      </li>
                                    )
                                  )}
                                </ul>
                              )}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <p>No orders found.</p>
        )}
      </div>
    </div>
  );
};

export default OrdersPage;
